<template>
  <div class="word_cloud mx-3 mt-4">
    <b-table :fields="fields" thead-class="head-table-green" hover :items="top_search"></b-table>
    <!-- <vue-word-cloud
      style="height: 480px; width: 640px; text-align: center"
      :color="
        () => this.colors_set[Math.floor(Math.random() * colors_set.length)]
      "
      :words="top_search"
      font-family="Kanit"
    /> -->
  </div>
</template>

<script>
// @ is an alias to /src
import VueWordCloud from "vuewordcloud";
import { mapState } from "vuex";

export default {
  name: "network_chart",
  components: {
    [VueWordCloud.name]: VueWordCloud,
  },
  data() {
    return {
      colors_set: ["#3B5286", "#5CA7A0", "#CBE54E", "#5D6E1E", "#94B447"],
      fields: [
        { key: 'id', label: 'ลำดับ' },
        { key: 'text', label: 'ชื่อพันธุ์พืช' },
        { key: 'weight', label: 'จำนวนที่ค้นหา' }
      ]
    };
  },
  mounted() {},
  methods: {},
  computed: {
    ...mapState({
      top_search: (state) => {
        return state.dashboardModule.top_search_be;
      },
    }),
  },
};
</script>
<style lang="scss">
.word_cloud {
  display: flex;
  justify-content: center;
}
</style>
